import PushNotification from 'services/PushNotification';
import StorageService from 'services/StorageService'

const init = () => {
    if (!PROJECT_ENV.authDevelopment && 'serviceWorker' in navigator) {
        window.addEventListener('load', () => {
            navigator.serviceWorker.register('/sw.js').then(registration => {
                const swUpdate = StorageService.getItem('sw-update');
                if(!swUpdate){
                    StorageService.setItem('sw-update', new Date().getTime());
                    if(registration && registration.update) registration.update();
                }
            }).catch(registrationError => {
                /* eslint-disable no-console */
                console.log('SW registration failed: ', registrationError);
            });

            PushNotification.init();
        });
    }
}

const ServiceWorker = {
    init
}

export default ServiceWorker;
